export default {
  dropdownLoadingText: 'Loading...',
  dropdownLoadingError: 'Sorry. A technical problem occurred during the request.',
  retryLinkText: 'Please try again',
  disabled: 'Disabled',
  error: 'Error',
};
